import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

let store = require('../store').default;

export const routes = [
    // {
    //     path: '/',
    //     name: 'home',
    //     component: Home,
    //     meta: {
    //         metaInfo: {
    //             title: "Grossiste pret a porter Paris : grossiste vetements en ligne femme, homme, enfant | eFashion Paris",
    //             keywords: "grossiste prêt à porter, grossiste pret a porter, grossiste prêt à porter paris, grossiste pret a porter paris, grossiste pret a porter en ligne, grossiste vetements paris",
    //             description: "eFashion Paris : Plateforme grossiste de prêt à porter et vêtements pour femmes, homme et enfants, spécialisé dans la mode made in Paris. Plus de 5000 produits mode en ligne."
    //         }
    //     }
    // },
    {
        path: '/',
        name: 'home',
        // meta: {
        //     requireAuth: true
        // },
        component: () => lazyLoadRoute(import('../views/HomeLogin.vue'))
    },
    {
        path: '/homepage',
        name: 'homepage',
        meta: {
            requireAuth: true
        },
        component: () => lazyLoadRoute(import('../views/HomeLogin.vue'))
    },
    {
        path: '/downloadApp',
        name: 'downloadApp',
        component: () => lazyLoadRoute(import('../views/DownloadApp.vue'))
    },
    {
        path: '/login',
        name: 'login',
        component: () => lazyLoadRoute(import('../views/Login.vue'))
    },
    {
        path: '/sign',
        name: 'sign',
        component: () => lazyLoadRoute(import('../views/Sign/Sign.vue')),
        children: [
            {
                path: '',
                name: 'choose',
                component: () => lazyLoadRoute(import( '../views/Sign/Choose.vue'))
            },
            {
                path: 'choose',
                name: 'choose',
                component: () => lazyLoadRoute(import( '../views/Sign/Choose.vue'))
            },
            {
                path: 'signpage/:type',
                name: 'signpage',
                component: () => lazyLoadRoute(import( '../views/Sign/SignPage.vue'))
            },
            {
                path: 'signsuc',
                name: 'signsuc',
                component: () => lazyLoadRoute(import( '../views/Sign/SignSuc.vue'))
            },
        ]
    },
    {
        path: '/about',
        name: 'about',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => lazyLoadRoute(import(/* webpackChunkName: "about" */ '../views/About.vue'))
    },
    {//收藏
        path: '/favoris',
        name: 'favoris',
        component: () => lazyLoadRoute(import('../views/Favoris.vue')),
        children: [
            {
                path: '',
                meta: {
                    requireAuth: true
                },
                component: () => lazyLoadRoute(import( '../views/Favoris/Articles.vue'))
            },
            {
                path: 'articles',
                name: 'Articles',
                meta: {
                    requireAuth: true
                },
                component: () => lazyLoadRoute(import( '../views/Favoris/Articles.vue'))
            },
            {
                path: 'vendeurs',
                name: 'Vendeurs',
                meta: {
                    requireAuth: true
                },
                component: () => lazyLoadRoute(import('../views/Favoris/Vendeurs.vue'))
            },
            {
                path: 'hstorique',
                name: 'historique',
                meta: {
                    requireAuth: true
                },
                component: () => lazyLoadRoute(import('../views/Favoris/Historique.vue'))
            },
        ],
        redirect: '/favoris/Articles'
    },
    {//我的
        path: '/moncompte',
        name: 'Moncompte',
        component: () => lazyLoadRoute(import('../views/Moncompte.vue')),
        children: [
            {
                path: '',
                meta: {
                    requireAuth: true
                },
                component: () => lazyLoadRoute(import( '../views/Moncompte/Informations.vue'))
            },
            {
                path: 'informations',
                name: 'Mes informations',
                meta: {
                    requireAuth: true
                },
                component: () => lazyLoadRoute(import( '../views/Moncompte/Informations.vue'))
            },
            {
                path: 'entreprise',
                name: 'Mon entreprise',
                meta: {
                    requireAuth: true
                },
                component: () => lazyLoadRoute(import('../views/Moncompte/Entreprise.vue'))
            },
            {
                path: 'adresses',
                name: 'Mes adresses',
                meta: {
                    requireAuth: true
                },
                component: () => lazyLoadRoute(import('../views/Moncompte/Adresses.vue'))
            },
            {
                path: 'transporteurs',
                name: 'Mes transporteurs',
                meta: {
                    requireAuth: true
                },
                component: () => lazyLoadRoute(import('../views/Moncompte/Transporteurs.vue'))
            },
            {
                path: 'moyens',
                name: 'Mes moyens de paiement',
                meta: {
                    requireAuth: true
                },
                component: () => lazyLoadRoute(import('../views/Moncompte/Moyens.vue'))
            },
            {
                path: 'crticles',
                name: 'mon-articles',
                meta: {
                    requireAuth: true
                },
                component: () => lazyLoadRoute(import('../views/Moncompte/Articles.vue'))
            },
            {
                path: 'commandes',
                name: 'Mes commandes',
                meta: {
                    requireAuth: true
                },
                component: () => lazyLoadRoute(import('../views/Moncompte/Commandes.vue')),

            },
        ],
        redirect: '/Moncompte/Informations'
    },
    {
        path: '/checkout',
        name: 'Checkout',
        component: () => lazyLoadRoute(import('../views/Checkout.vue')),
        children: [
            {
                path: 'transport',
                name: 'Adresses-transport',
                meta: {
                    progress: 2,
                    requireAuth: true
                },
                component: () => lazyLoadRoute(import( '../views/Checkout/transport.vue'))
            },

            {
                path: 'paiement',
                name: 'moyen de paiement',
                meta: {
                    progress: 3,
                    requireAuth: true
                },
                component: () => lazyLoadRoute(import( '../views/Checkout/paiement.vue'))
            },
            {
                path: 'confirmation',
                name: 'moyen de paiement',
                meta: {
                    progress: 4,
                    requireAuth: true
                },
                component: () => lazyLoadRoute(import( '../views/Checkout/Confirmation.vue'))
            },

        ]

    },
    {
        path: '/commandes',
        meta: {
            requireAuth: true
        },
        component: () => lazyLoadRoute(import('../views/Commandes2.vue'))
    },
    {
        path: '/result',
        name: 'result',
        // meta:{
        //   requireAuth:true
        // },
        component: () => lazyLoadRoute(import('../views/Checkout/result')),
    },
    {
        path: '/register-success',
        name: 'register-success',
        component: () => lazyLoadRoute(import('../views/Checkout/registerSuccess')),
    },
    {//购物车
        path: '/panier',
        name: 'Panier',
        meta: {
            requireAuth: true
        },
        component: () => lazyLoadRoute(import('../views/Panier')),
    },
    {
        path: '/productList/:id',
        name: 'ProductList',
        // meta: {
        //     requireAuth: true
        // },
        component: () => lazyLoadRoute(import('../views/ProductList')),
    }, ,
    {
        path: '/productList',
        name: 'ProductList',
        meta: {
            // requireAuth:true
        },
        component: () => lazyLoadRoute(import('../views/ProductList')),
    },
    {//商家产品列表
        path: '/vendeur/:id',
        name: 'vendeur',
        meta: {
            // requireAuth: true
        },
        component: () => lazyLoadRoute(import('../views/vendeur')),
    },
    {//商家产品列表
        path: '/vendeur',
        name: 'vendeur',
        meta: {
            // requireAuth: true
        },
        component: () => lazyLoadRoute(import('../views/vendeur')),
    },
    {
        path: '/Nouveautes/:id',
        name: 'Nouveautes',
        meta: {
            requireAuth: true
        },
        component: () => lazyLoadRoute(import('../views/Nouveautes')),
    },
    {
        path: '/productDetail',
        name: 'ProductDetail',
        meta: {
            // requireAuth:true,
        },
        component: () => lazyLoadRoute(import('../views/ProductDetail')),
    },
    {
        path: '/Help',
        name: 'Help',
        component: () => lazyLoadRoute(import('../views/Help')),
    },
    {
        path: '/MarquesList',
        name: 'MarquesList',
        component: () => lazyLoadRoute(import('../views/MarquesList')),
    },
    {
        path: "/404",
        name: "notFound",
        component: () => lazyLoadRoute(import('../views/404')),
    },
    {
        path: "/conditions",
        name: "conditions",
        component: () => lazyLoadRoute(import('../views/Conditions')),
        children: [
            {
                path: 'commonPage',
                name: 'commonPage',
                component: () => lazyLoadRoute(import('../views/Conditions/CommonPage'))
            },
            {
                path: 'contact',
                name: 'contact',
                component: () => lazyLoadRoute(import('../views/Conditions/Contact'))
            }
        ]
    },
    {
        path: "/resetPassword",
        name: "resetPassword",
        component: () => lazyLoadRoute(import('../views/ResetPassword')),
    },
    {
        path: "/sellWellProductList",
        name: "sellWellProductList",
        component: () => lazyLoadRoute(import('../views/SellWellProductList')),
    },
    {
        path: "/tendances",
        name: "tendances",
        component: () => lazyLoadRoute(import('../views/Tendances')),
    },
    {
        path: "/promotions",
        name: "promotions",
        component: () => lazyLoadRoute(import('../views/Promotions')),
    },
    {
        path: "/campagne",
        name: "campagne",
        component: () => lazyLoadRoute(import('../views/Campagne')),
    },
    {
        path: "/printCommandes",
        name: "printCommandes",
        component: () => lazyLoadRoute(import('../views/PrintCommandes')),
    },
    {
        path: '/payGreenV3',
        name: 'payGreenV3',
        meta: {
            requireAuth: true
        },
        component: () => lazyLoadRoute(import('../views/PayGreenV3')),
    },


    {
        path: "/admin/pageImgSet",
        name: "admin/pageImgSet",
        meta: {
            requireAdminAuth: true,
        },
        component: () => lazyLoadRoute(import('../views/admin/PageImgSet')),
    },
    {
        path: "/admin/tendancesSet",
        name: "admin/tendancesSet",
        meta: {
            requireAdminAuth: true,
        },
        component: () => lazyLoadRoute(import('../views/admin/TendancesSet')),
    },
    {
        path: "/admin/configSystemSet",
        name: "admin/configSystemSet",
        meta: {
            requireAdminAuth: true,
        },
        component: () => lazyLoadRoute(import('../views/admin/ConfigSystemSet')),
    },
    {
        path: "/admin/pageMetaSet",
        name: "admin/pageMetaSet",
        meta: {
            requireAdminAuth: true,
        },
        component: () => lazyLoadRoute(import('../views/admin/PageMetaSet')),
    },
    {
        path: "*", // 此处需特别注意置于最底部
        redirect: "/404"
    }
]


const router = new VueRouter({
    mode: 'history',
    // base:'/base/',
    routes
})

if (!store.state.isMobile) {
    //桌面端时 把所有push的跳转都变成新标签页
    router.push = function (obj) {
        const {href} = router.resolve(obj);
        window.open(href, '_blank');
    }
}


router.beforeEach((to, from, next) => {
    let token = localStorage.getItem('token')
    if (to.meta.requireAuth) {
        token && next()
        !token && next({name: 'home'})
    } else if (to.meta.requireAdminAuth) {
        if (store.state.userInfo.type != 'admin') {
            return next({name: 'home'})
        }
        next();
    } else {
        if (store.state.userInfo.type == 'admin') return next();
        let is_next = to.name.match(/(login|home|sign|choose|signpage|signsuc)/i)
        if (token && is_next) next({name: 'homepage', query: to.query})
        else next()
    }
})

//在准备好录入的时候要把禁止关闭； prerender seo
setLimitTypeInGoogle(routes, false);

//设置是否禁止录入搜索引擎 limit true表示禁止
function setLimitTypeInGoogle(routes, limit) {
    routes.forEach(route => {
        if (!route.meta) route.meta = {};
        if (limit) route.meta.robots = `noindex, nofollow`;
    })
}

const lazyLoadRoute = AsyncView => {
    const AsyncHandler = () => ({
        component: AsyncView,
    });

    return Promise.resolve({
        functional: true,
        render(h, {data, children}) {
            // Transparently pass any props or children
            // to the view component.
            return h(AsyncHandler, data, children);
        }
    });
};

export default router
